module.exports = __webpack_public_path__ + "src/assets/games/21/118.jpg";